module.exports = __webpack_public_path__ + "img/visa-debito.fe1b0117.svg";